export default __webpack_public_path__ + "static/media/alarmClearInput.1f85de25.png";